import { ConfigValue } from "../config";
import Cookies from "js-cookie";
import { AdminUser } from "./types";
import CryptoJS from "crypto-js";

export const AUTH_TOKEN_KEY = ConfigValue.AUTH_TOKEN_KEY;
export const AUTH_USER_INFO = ConfigValue.AUTH_USER_INFO;

export const getAuthToken = () => {
  if (typeof window === undefined) {
    return null;
  }
  return Cookies.get(AUTH_TOKEN_KEY);
};

export function setAuthToken(token: string) {
  Cookies.set(AUTH_TOKEN_KEY, token, { expires: 1 });
}

export function removeAuthToken() {
  Cookies.remove(AUTH_TOKEN_KEY);
}

export function checkHasAuthToken() {
  const token = Cookies.get(AUTH_TOKEN_KEY);
  if (!token) return false;
  return true;
}

export const getAuthUserInfo = () => {
  if (typeof window === "undefined") {
    return null;
  }

  let value = Cookies.get(AUTH_USER_INFO);
  if (!value) {
    try {
      value = localStorage.getItem(AUTH_USER_INFO) || undefined;
    } catch (e) {}
  }
  if (value && ConfigValue.CRYPTO_SECRET_PASS) {
    try {
      const bytes = CryptoJS.AES.decrypt(value, ConfigValue.CRYPTO_SECRET_PASS);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decrypted);
    } catch (e) {
      return null;
    }
  } else {
    return null;
  }
};

export function setAuthUserInfo(info: AdminUser, password?: string) {
  const rawPermissions =
    info?.permissions || info?.role?.permissions || [];

  const normalizedPermissions = Array.isArray(rawPermissions)
    ? rawPermissions.map((p: any) => ({
        id: p.id ?? p.permission_id,
        name: p.name ?? p.permission_name,
        permission_id: p.permission_id ?? p.id,
        permission_name: p.permission_name ?? p.name,
        permission_description: p.permission_description ?? null,
        can_add: Boolean(p.can_add),
        can_edit: Boolean(p.can_edit),
        can_list: Boolean(p.can_list),
        can_view: Boolean(p.can_view),
        can_delete: Boolean(p.can_delete),
        can_approve_reject: Boolean(p.can_approve_reject),
        can_export: Boolean(p.can_export),
        can_download: Boolean(p.can_download),
        can_block: Boolean(p.can_block),
      }))
    : [];

  const filteredInfo = {
    ...info,
    permissions: normalizedPermissions,
    role: info?.role
      ? {
          ...info.role,
          permissions: normalizedPermissions,
        }
      : undefined,
  };

  const data = CryptoJS.AES.encrypt(
    JSON.stringify({ ...filteredInfo, password: password || info?.password || "" }),
    ConfigValue.CRYPTO_SECRET_PASS as string
  ).toString();

  try {
    Cookies.remove(AUTH_USER_INFO);
  } catch (e) {}

  try {
    localStorage.removeItem(AUTH_USER_INFO);
  } catch (e) {}

  try {
    Cookies.set(AUTH_USER_INFO, data, {
      expires: 1,
    });
  } catch (e) {}

  try {
    localStorage.setItem(AUTH_USER_INFO, data);
  } catch (e) {}
}

export function removeAuthUserInfo() {
  Cookies.remove(AUTH_USER_INFO);
  try {
    localStorage.removeItem(AUTH_USER_INFO);
  } catch (e) {}
}
